/** @format */

export const init = {
  activeCategory: "",
  activeSubChildren: "",
  name: "",
  subChildren: [],
  charater: "A",
  loader: true,
  brandData: [],
  category: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "initial_data":
      return {
        ...state,
        activeCategory: action.activeCategory,
        activeSubChildren: action.activeSubChildren,
        subChildren: action.subChildren,
        name: action.name,
        charater: action.charater,
        category: action.category,
      };
    case "set_brand_data":
      return {
        ...state,
        brandData: action.brandData,
        loader: false,
      };
    case "set_charater":
      return {
        ...state,
        charater: action.charater,
        loader: true,
      };
    case "change_category":
      return {
        ...state,
        activeCategory: action.activeCategory,
        activeSubChildren: action.activeSubChildren,
        subChildren: action.subChildren,
        name: action.name,
        charater: "A",
        loader: true,
        category: action.category,
      };
    case "change_sub_category":
      return {
        ...state,
        activeSubChildren: action.activeSubChildren,
        charater: "A",
        loader: true,
        name: action.name || state.name,
      };
    default:
      return state;
  }
};
